<div class="page-contents">
    <div [ngClass]="{'blockContainer': !setFullWindow , 'levelOne-full-container':setFullWindow}" id='levelOne'>
      <div class="pageTitle">
        {{title}}
  
        <i class="material-icons pullfloat-right" [routerLink]="['/home']">close</i>
  
        <i class="material-icons pullfloat-right" *ngIf="!component || component.hostView.destroyed" (click)="setFullWindow = !setFullWindow">
          {{setFullWindow?'photo_size_select_small':'fullscreen'}}
        </i>
      </div>
      <div class="searchInputGroup">
        <div class="searchIcon" (click)="filterMenu(searchInput.value) ">
          <i class="fas fa-search fa-lg"></i>
        </div>
        <input #searchInput class="searchInput" type="text" placeholder="SEARCH THE MENU" (keyup)="filterMenu(searchInput.value)">
  
      </div>
  
      <div class="menuBlock">
        <ul class="list-group list-group-flush" *ngFor="let item of (menulist$|async)">
          <li class="list-group-item" [routerLink]="item.menuRouter">
            <i class="fas" [class]="item.menuIcon"></i>
            &nbsp;&nbsp;{{item.menuName}}</li>
        </ul>
  
      </div>
  
  
      <!-- <div class="adBlock">
          <app-bot-ad></app-bot-ad>
        </div> -->
  
    </div>
    <div class="entry-container">
      <router-outlet></router-outlet>
    </div>
  
  </div>